export interface MenuItem {
  title: string;
  icon?: string;
  routerLink: string;
  feature?: string;
  subItems?: MenuItem[];
  permissions?: string[];
  isLocked?: boolean;
  badgeCount?: number;
  isExpanded?: boolean;
}

export const studentMenuItems = [
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/student-dashboard/welcome",
    subItems: [],
    permissions: [],
  },

  {
    title: "New Application",
    icon: "content_copy",
    routerLink: "/student-dashboard/application-form",
    permissions: [],
  },
  {
    title: "Applications",
    icon: "folder",
    routerLink: "/student-dashboard/applications",
    permissions: [],
  },
  {
    title: "Enrollment",
    icon: "receipt",
    routerLink: "/student-dashboard/enrollment-table",
    permissions: [],
  },
  {
    title: "Announcements",
    icon: "campaign",
    routerLink: "/student-dashboard/announcements",
    permissions: [],
  },
  {
    title: "Discount Codes",
    icon: "local_offer",
    routerLink: "/student-dashboard/discount-codes",
    permissions: [],
  },

  {
    title: "Checklist",
    icon: "verified",
    routerLink: "/student-dashboard/checklist",
  },

  {
    title: "Career Opportunities",
    icon: "work_outline",
    routerLink: "/student-dashboard/career-opportunity",
  },

  {
    title: "Account Holds",
    icon: "block",
    routerLink: "/student-dashboard/account-holds",
  },

  {
    title: "Finance & Transactions",
    icon: "schedule",
    routerLink: "/student-dashboard/payment-schedule",
    subItems: [
      {
        title: "Payment Transactions",
        icon: "payment",
        routerLink: "/student-dashboard/payment-summary",
      },
      {
        title: "Payment Plan Schedules",
        icon: "schedule",
        routerLink: "/student-dashboard/payment-schedule",
      },
    ],
  },
  {
    title: "Message Panel",
    icon: "chat_bubble_outline",
    routerLink: "/student-dashboard/message-panel",
    subItems: [],
  },

  {
    title: "Required Forms",
    icon: "description",
    routerLink: "/student-dashboard/student-required-forms",
    subItems: [],
  },

  {
    title: "Student Resources",
    icon: "assignment",
    routerLink: "/student-dashboard/student-resource",
  },
];

export const adminMenuItems: MenuItem[] = [
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/admin-dashboard/welcome",
  },

  /* =========================
     College Management
  ========================== */
  {
    title: "Institution Management",
    icon: "domain",
    routerLink: null as any,
    subItems: [
      {
        title: "Announcements",
        routerLink: "/admin-dashboard/announcements",
      },
      {
        title: "College Leads",
        routerLink: "/admin-dashboard/college-leads",
      },
      {
        title: "Colleges",
        routerLink: "/admin-dashboard/college-management",
      },
      {
        title: "Templates",
        routerLink: "/admin-dashboard/admin-template",
      },
      {
        title: "Payment Settings",
        routerLink: "/admin-dashboard/payment-options",
      },
    ],
  },

  /* =========================
     Academics
  ========================== */
  {
    title: "Academics",
    icon: "school",
    routerLink: null as any,
    subItems: [
      {
        title: "Applications",
        routerLink: "/admin-dashboard/applications",
      },
      {
        title: "Enrollment",
        routerLink: "/admin-dashboard/enrollment",
      },
      {
        title: "Programs",
        routerLink: "/admin-dashboard/programs",
      },
      {
        title: "Schedule Type",
        routerLink: "/admin-dashboard/schedule-type",
      },
      {
        title: "Schedules",
        routerLink: "/admin-dashboard/schedules",
      },
      {
        title: "Program Dates",
        routerLink: "/admin-dashboard/program-dates",
      },
      {
        title: "Fee Components",
        routerLink: "/admin-dashboard/fees-components",
      },
      {
        title: "Tuition & Fees",
        routerLink: "/admin-dashboard/tuition-fees",
      },
    ],
  },


  {
    title: "Callpad",
    icon: "dialpad",
    routerLink: "/admin-dashboard/callpad",
  },
  {
    title: "Message Center",
    icon: "settings_input_antenna",
    routerLink: "/admin-dashboard/message-center",
  },
  {
    title: "Certification",
    icon: "verified_user",
    routerLink: null as any,
    subItems: [
      {
        title: "Clearance",
        routerLink: "/admin-dashboard/clearance",
      },
      {
        title: "Checklist",
        routerLink: "/admin-dashboard/checklist",
      },
      {
        title: "Checklist Form",
        routerLink: "/admin-dashboard/checklist-form",
      },
      {
        title: "Completion",
        routerLink: "/admin-dashboard/completion",
      },
      {
        title: "Transcripts",
        routerLink: "/admin-dashboard/transcript",
      },
    ],
  },
  {
    title: "Employment",
    icon: "work_outline",
    routerLink: "/admin-dashboard/employment-status",
  },

  /* =========================
     Billing
  ========================== */
  {
    title: "Billing",
    icon: "receipt_long",
    routerLink: null as any,
    subItems: [
      {
        title: "Plans",
        routerLink: "/admin-dashboard/pricing-plans",
      },
      {
        title: "Subscriptions",
        routerLink: "/admin-dashboard/subscriptions",
      },
      {
        title: "Invoice",
        routerLink: "/admin-dashboard/invoice",
      },
      {
        title: "Payment",
        routerLink: "/admin-dashboard/payment-billing",
      },
    ],
  },

  /* =========================
     Finance & Transactions
  ========================== */
  {
    title: "Finance & Transactions",
    icon: "account_balance",
    routerLink: null as any,
    subItems: [
      {
        title: "Payment Overview",
        routerLink: "/admin-dashboard/payment-overview",
      },
      {
        title: "Payment Transactions",
        routerLink: "/admin-dashboard/payment-summary",
      },
      {
        title: "Payment Schedule",
        routerLink: "/admin-dashboard/payment-schedule",
      },
      {
        title: "Refunds",
        routerLink: "/admin-dashboard/refunds",
      },
      {
        title: "Payment Report",
        routerLink: "/admin-dashboard/payments-report",
      },
      {
        title: "Revenue Report",
        routerLink: "/admin-dashboard/revenue-report",
      },
    ],
  },

  /* =========================
     Reports
  ========================== */
  {
    title: "Reports",
    icon: "analytics",
    routerLink: null as any,
    subItems: [
      {
        title: "Application Report",
        routerLink: "/admin-dashboard/application-report",
      },
      {
        title: "Employment Status Report",
        routerLink: "/admin-dashboard/employment-status-report",
      },
    ],
  },

  /* =========================
     communications
  ========================== */

  {
    title: "communications",
    icon: "email",
    routerLink: null as any,
    subItems: [
      {
        title: "Email Notification",
        routerLink: "/admin-dashboard/email-notifications",
      },
      {
        title: "Message Center",
        // icon: "settings_input_antenna",
        routerLink: "/admin-dashboard/message-center",
      },
      {
        title: "Message Templates",
        routerLink: "/admin-dashboard/message-templates",
      },
      {
        title: "Message Panel",
        routerLink: "/admin-dashboard/message-panel",
      },
    ],
  },

  /* =========================
     Administration
  ========================== */
  {
    title: "Administration",
    icon: "admin_panel_settings",
    routerLink: null as any,
    subItems: [
      {
        title: "Users",
        routerLink: "/admin-dashboard/users",
      },
      {
        title: "Permissions",
        routerLink: null as any,
        subItems: [
          {
            title: "User Permissions",
            routerLink: "/admin-dashboard/permissions/user-permissions",
          },
          {
            title: "Role Permissions",
            routerLink: "/admin-dashboard/permissions/role-permissions",
          },
        ],
      },
      {
        title: "Email Notification",
        routerLink: "/admin-dashboard/email-notifications",
      },
      {
        title: "Discount Codes",
        routerLink: "/admin-dashboard/discount-codes",
      },
      {
        title: "Message Templates",
        routerLink: "/admin-dashboard/message-templates",
      },
      {
        title: "Message Panel",
        routerLink: "/admin-dashboard/message-panel",
      },
    ],
  },
];

export const facultyAdminMenuItems: MenuItem[] = [
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/faculty-admin-dashboard",
  },

  {
    title: "Completion",
    icon: "receipt_long",
    routerLink: "/faculty-admin-dashboard/completion",
  },

  {
    title: "Communications",
    icon: "announcement",
    routerLink: null as any,
    subItems: [
      {
        title: "Message Center",
        // icon: "settings_input_antenna",
        routerLink: "/faculty-admin-dashboard/message-center",
      },
      {
        title: "Message Panel",
        icon: "chat",
        routerLink: "/faculty-admin-dashboard/message-panel",
      },
      {
        title: "Announcements",
        routerLink: "/faculty-admin-dashboard/announcements",
      },
    ],
  },

  {
    title: "Student Resources",
    icon: "library_books",
    routerLink: "/faculty-admin-dashboard/student-resources",
  },

  {
    title: "Students",
    icon: "groups",
    routerLink: "/faculty-admin-dashboard/student-management",
  },

  {
    title: "Program Dates",
    icon: "date_range",
    routerLink: "/faculty-admin-dashboard/program-dates",
  },

  {
    title: "End Of Program",
    icon: "account_box",
    routerLink: "/faculty-admin-dashboard/end-of-program",
  },

  //attendance

  {
    title: "Attendance",
    icon: "account_box",
    routerLink: null as any,
    subItems: [
      {
        title: "Record Attendance",
        routerLink: "/faculty-admin-dashboard/record-attendance",
      },
      //attendance records
      {
        title: "Attendance Records",
        routerLink: "/faculty-admin-dashboard/attendance-records",
      },

      {
        title: "Attendance Reports",
        routerLink: "/faculty-admin-dashboard/attendance-reports",
      },
    ],
  },

  {
    title: "Reports",
    icon: "analytics",
    routerLink: null as any,
    subItems: [
      {
        title: "Application Report",
        routerLink: "/faculty-admin-dashboard/application-report",
      },
      {
        title: "Employment Status Report",
        routerLink: "/faculty-admin-dashboard/employment-status-report",
      },
    ],
  },

  {
    title: "Profile",
    icon: "receipt_long",
    routerLink: "/faculty-admin-dashboard/my-profile",
  },
];

//add hr admin menu items here
export const hrAdminMenuItems: MenuItem[] = [
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/hr-admin-dashboard/welcome",
  },

  {
    title: "Internal Vacancies",
    icon: "work_outline",
    routerLink: "/hr-admin-dashboard/vacancies",
  },

  {
    title: "Department Management",
    icon: "business",
    routerLink: "/hr-admin-dashboard/department",
  },
  {
    title: "Applications",
    icon: "group",
    routerLink: "/hr-admin-dashboard/applications",
  },
  {
    title: "Job Placements",
    icon: "work",
    routerLink: "/hr-admin-dashboard/jobs",
  },
  {
    title: "Hired Applicants",
    icon: "business",
    routerLink: "/hr-admin-dashboard/hired-applicants",
  },
];

//add applicant admin menu items here
export const applicantAdminMenuItems: MenuItem[] = [
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/applicant-admin-dashboard",
  },
  {
    title: "My Applications",
    icon: "description",
    routerLink: "/applicant-admin-dashboard/job-application-table",
  },
  {
    title: "Vaccancies",
    icon: "business",
    routerLink: "/applicant-admin-dashboard/job-listings",
  },
  // {
  //   title: "Student Management",
  //   icon: "groups",
  //   routerLink: "/hr-admin-dashboard/student-management",
  // },

  // {
  //   title: "Program Dates",
  //   icon: "date_range",
  //   routerLink: "/hr-admin-dashboard/program-dates",
  // },

  // {
  //   title: "End Of Program",
  //   icon: "account_box",
  //   routerLink: "/hr-admin-dashboard/end-of-program",
  // },
];

// export const collegeAdminMenuItems: MenuItem[] = [
//   /* =========================
//      Dashboard
//   ========================== */
//   {
//     title: "Dashboard",
//     icon: "dashboard",
//     routerLink: "/college-admin-dashboard/welcome",
//   },

//   {
//     title: "Recruiter Performance",
//     icon: "leaderboard",
//     routerLink: "/college-admin-dashboard/student-recruitors-performamce",
//   },

//   {
//     title: "Positons",
//     icon: "work_outline",
//     routerLink: "/college-admin-dashboard/positions",
//   },

//   {
//     title: "Scholarships",
//     icon: "school",
//     routerLink: "/college-admin-dashboard/scholarship-master",
//     subItems: [
//       {
//         title: "Scholarship Master",
//         icon: "card_giftcard",
//         routerLink: "/college-admin-dashboard/scholarship-master",
//       },
//       {
//         title: "Scholarship Awards",
//         icon: "card_giftcard",
//         routerLink: "/college-admin-dashboard/scholarship-awards",
//       },
//     ],
//   },

//   /* =========================
//      Academics
//   ========================== */
//   {
//     title: "Academics",
//     icon: "school",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Applications",
//         routerLink: "/college-admin-dashboard/applications",
//         feature: "Application",
//       },
//       {
//         title: "Enrollment",
//         routerLink: "/college-admin-dashboard/enrollment",
//         feature: "Enrollment",
//       },
//       {
//         title: "Programs",
//         routerLink: "/college-admin-dashboard/programs",
//         feature: "Programs",
//       },
//       {
//         title: "Schedule Type",
//         routerLink: "/college-admin-dashboard/schedule-type",
//         feature: "Schedule Type",
//       },
//       {
//         title: "Schedules",
//         routerLink: "/college-admin-dashboard/schedules",
//         feature: "Schedules",
//       },
//       {
//         title: "Program Dates",
//         routerLink: "/college-admin-dashboard/program-dates",
//         feature: "Program Dates",
//       },
//       {
//         title: "Fee Components",
//         routerLink: "/college-admin-dashboard/fees-components",
//         feature: "Fee Component",
//       },
//       {
//         title: "Tuition & Fees",
//         routerLink: "/college-admin-dashboard/tuition-fees",
//         feature: "Tuition & Fees",
//       },
//     ],
//   },

//   /* =========================
//      Communications
//   ========================== */
//   {
//     title: "Communications",
//     icon: "announcement",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Announcements",
//         routerLink: "/college-admin-dashboard/announcements",
//         feature: "Announcements",
//       },
//       {
//         title: "Message Center",
//         // icon: "settings_input_antenna",
//         routerLink: "/college-admin-dashboard/message-center",
//       },
//       {
//         title: "Message Panel",
//         routerLink: "/college-admin-dashboard/message-panel",
//       },
//     ],
//   },

//   /* =========================
//      Certification
//   ========================== */
//   {
//     title: "Certification",
//     icon: "verified_user",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Clearance",
//         routerLink: "/college-admin-dashboard/clearance",
//         feature: "Clearance",
//       },
//       {
//         title: "Checklist",
//         routerLink: "/college-admin-dashboard/checklist",
//         feature: "Checklist",
//       },
//       {
//         title: "Checklist Form",
//         routerLink: "/college-admin-dashboard/checklist-form",
//         feature: "Checklist Form",
//       },
//       {
//         title: "Completion",
//         routerLink: "/college-admin-dashboard/completion",
//         feature: "Completion",
//       },
//       {
//         title: "Transcripts",
//         routerLink: "/college-admin-dashboard/transcript",
//         feature: "Transcripts",
//       },
//     ],
//   },

//   /* =========================
//      Callpad
//   ========================== */
//   {
//     title: "Callpad",
//     icon: "dialpad",
//     routerLink: "/college-admin-dashboard/callpad",
//     feature: "Callpad",
//   },

//   /* =========================
//      Student Holds
//   ========================== */

//   {
//     title: "Student Holds",
//     icon: "block",
//     routerLink: "/college-admin-dashboard/student-holds",
//     feature: "Student Holds",
//   },

//   {
//     title: "End Of Program",
//     icon: "account_box",
//     routerLink: "/college-admin-dashboard/end-of-program",
//     feature: "End Of Program",
//   },

//   /* =========================
//      College Profile
//   ========================== */
//   {
//     title: "Student Profile",
//     icon: "account_circle",
//     routerLink: "/college-admin-dashboard/student-profile",
//     feature: "Student Profile",
//   },

//   /* =========================
//      Tuition & Fees
//   ========================== 
//   {
//     title: "Tuition & Fees",
//     icon: "payments",
//     routerLink: null as any,
//     subItems: [

//     ],
//   },*/

//   /* =========================
//      Employment
//   ========================== */
//   {
//     title: "Employment",
//     icon: "work_outline",
//     routerLink: "/college-admin-dashboard/employment-status",
//     feature: "Employment",
//   },

//   {
//     title: "Job Placements",
//     icon: "work",
//     routerLink: "/college-admin-dashboard/jobs",
//     //feature: "Job Placements",
//   },

//   /* =========================
//      Finance & Transactions
//   ========================== */
//   {
//     title: "Finance & Transactions",
//     icon: "account_balance",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Payment Overview",
//         routerLink: "/college-admin-dashboard/payment-overview",
//         feature: "Payment Overview",
//       },
//       {
//         title: "Payment Transactions",
//         routerLink: "/college-admin-dashboard/payment-summary",
//         feature: "Payment Transactions",
//       },
//       {
//         title: "Payment Schedule",
//         routerLink: "/college-admin-dashboard/payment-schedule",
//         feature: "Payment Schedule",
//       },

//       {
//         title: "Expenses",
//         routerLink: null as any,
//         subItems: [
//           {
//             title: "Expense Categories",
//             routerLink: "/college-admin-dashboard/expenses/expense-category",
//             // feature: "User Permissions",
//           },
//           {
//             title: "Expense Records",
//             routerLink: "/college-admin-dashboard/expenses/expense",
//             //feature: "Role Permissions",
//           },
//         ],
//       },
//       {
//         title: "Refunds",
//         routerLink: "/college-admin-dashboard/refunds",
//         feature: "Refunds",
//       },
//       {
//         title: "Payment Report",
//         routerLink: "/college-admin-dashboard/payments-report",
//         feature: "Payment Report",
//       },
//       {
//         title: "Revenue Report",
//         routerLink: "/college-admin-dashboard/revenue-report",
//         feature: "Revenue Report",
//       },
//     ],
//   },
//   /* =========================
//      Reports
//   ========================== */
//   {
//     title: "Reports",
//     icon: "analytics",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Application Report",
//         routerLink: "/college-admin-dashboard/application-report",
//         feature: "Application Report",
//       },
//       {
//         title: "Employment Status Report",
//         routerLink: "/college-admin-dashboard/employment-status-report",
//         feature: "Employment Status Report",
//       },
//     ],
//   },
//   {
//     title: "Forms & Resources",
//     icon: "description",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Required Forms",
//         icon: "description",
//         routerLink: "/college-admin-dashboard/required-forms",
//         feature: "Required Forms",
//       },

//       {
//         title: "Form Submissions",
//         icon: "assignment",
//         routerLink: "/college-admin-dashboard/form-submissions",
//         feature: "Form Submissions",
//       },

//       {
//         title: "Student Resources",
//         icon: "assignment",
//         routerLink: "/college-admin-dashboard/student-resources",
//         feature: "Student Resources",
//       },
//     ],
//   },

//   {
//     title: "AUDIT LOGS",
//     icon: "account_circle",
//     routerLink: "/college-admin-dashboard/audit-log",
//     //feature: "Audit Logs",
//   },

//   /* =========================
//      Administration
//   ========================== */
//   {
//     title: "Administration",
//     icon: "admin_panel_settings",
//     routerLink: null as any,
//     subItems: [
//       {
//         title: "Users",
//         routerLink: "/college-admin-dashboard/users",
//         feature: "Users",
//       },

//       {
//         title: "Department",
//         routerLink: "/college-admin-dashboard/department",
//         //feature: "Department",
//       },

//       {
//         title: "Permissions",
//         routerLink: null as any,
//         subItems: [
//           {
//             title: "User Permissions",
//             routerLink: "/college-admin-dashboard/permissions/user-permissions",
//             // feature: "User Permissions",
//           },
//           {
//             title: "Role Permissions",
//             routerLink: "/college-admin-dashboard/permissions/role-permissions",
//             //feature: "Role Permissions",
//           },
//         ],
//       },
//       {
//         title: "Email Notifications",
//         routerLink: "/college-admin-dashboard/email-notifications",
//         feature: "Email Notifications",
//       },
//       {
//         title: "Discount Codes",
//         routerLink: "/college-admin-dashboard/discount-codes",
//         feature: "Discount Codes",
//       },
//     ],
//   },

//   /* =========================
//      Settings
//   ========================== */
//   {
//     title: "Settings",
//     icon: "settings",
//     routerLink: null as any,
//     subItems: [
//       // {
//       //   title: "Announcements",
//       //   routerLink: "/college-admin-dashboard/announcements",
//       //   feature: "Announcements",
//       // },
//       {
//         title: "Templates",
//         routerLink: "/college-admin-dashboard/college-template",
//         feature: "Templates",
//       },

//       {
//         title: "Billing",
//         icon: "receipt_long",
//         //feature: "Billing",
//         routerLink: null as any,
//         subItems: [
//           {
//             title: "Subscription",
//             routerLink: "/college-admin-dashboard/subscription",
//             feature: "Subscription",
//           },
//           {
//             title: "Invoices",
//             routerLink: "/college-admin-dashboard/invoices",
//             feature: "Invoices",
//           },
//           {
//             title: "Payment",
//             routerLink: "/college-admin-dashboard/payment-billing",
//             feature: "Payment",
//           },
//         ],
//       },
//       {
//         title: "Payment Settings",
//         routerLink: "/college-admin-dashboard/payment-options",
//         feature: "Payment Settings",
//       },

//       {
//         title: "College Profile",
//         icon: "account_circle",
//         routerLink: "/college-admin-dashboard/college-profile",
//         feature: "College Profile",
//       },
//     ],
//   },
// ];

export const collegeAdminMenuItems: MenuItem[] = [
  /* =========================
     Dashboard
  ========================== */
  {
    title: "Dashboard",
    icon: "dashboard",
    routerLink: "/college-admin-dashboard/welcome",
  },


  /* =========================
     Admissions
  ========================== */
  {
    title: "Admissions",
    icon: "how_to_reg",
    routerLink: null as any,
    subItems: [
      {
        title: "Applications",
        routerLink: "/college-admin-dashboard/applications",
        feature: "Application",
      },
      {
        title: "Enrollment",
        routerLink: "/college-admin-dashboard/enrollment",
        feature: "Enrollment",
      },
      {
        title: "Scholarships",
        icon: "school",
        routerLink: "/college-admin-dashboard/scholarship-master",
        subItems: [
          {
            title: "Scholarship Master",
            icon: "card_giftcard",
            routerLink:
              "/college-admin-dashboard/scholarship-master",
          },
          {
            title: "Scholarship Awards",
            icon: "card_giftcard",
            routerLink:
              "/college-admin-dashboard/scholarship-awards",
          },
        ],
      },

      {
        title: "Discount Codes",
        routerLink:
          "/college-admin-dashboard/discount-codes",
        feature: "Discount Codes",
      },

      {
        title: "Employment",
        icon: "work_outline",
        routerLink:
          "/college-admin-dashboard/employment-status",
        feature: "Employment",
      },
    ],
  },


  /* =========================
     Academics
  ========================== */
  {
    title: "Academics",
    icon: "school",
    routerLink: null as any,
    subItems: [
      {
        title: "Programs",
        routerLink: "/college-admin-dashboard/programs",
        feature: "Programs",
      },
      {
        title: "Schedule Types",
        routerLink:
          "/college-admin-dashboard/schedule-type",
        feature: "Schedule Type",
      },
      {
        title: "Schedules",
        routerLink: "/college-admin-dashboard/schedules",
        feature: "Schedules",
      },
      {
        title: "Program Dates",
        routerLink:
          "/college-admin-dashboard/program-dates",
        feature: "Program Dates",
      },
      {
        title: "Tuition & Fees",
        routerLink:
          "/college-admin-dashboard/tuition-fees",
        feature: "Tuition & Fees",
      },
      {
        title: "Fee Components",
        routerLink:
          "/college-admin-dashboard/fees-components",
        feature: "Fee Component",
      },
      {
        title: "Student Holds",
        icon: "block",
        routerLink:
          "/college-admin-dashboard/student-holds",
        feature: "Student Holds",
      },
      {
        title: "End Of Program",
        icon: "account_box",
        routerLink:
          "/college-admin-dashboard/end-of-program",
        feature: "End Of Program",
      },

    ],
  },
  /* =========================
   Recruiter Performance
========================== */
  {
    title: "Recruiter Performance",
    icon: "leaderboard",
    routerLink:
      "/college-admin-dashboard/student-recruitors-performamce",
  },

  /* =========================
     Student Services
  ========================== */
  {
    title: "Student Services",
    icon: "support_agent",
    routerLink: null as any,
    subItems: [
      {
        title: "Required Forms",
        icon: "description",
        routerLink:
          "/college-admin-dashboard/required-forms",
        feature: "Required Forms",
      },

      {
        title: "Form Submissions",
        icon: "assignment",
        routerLink:
          "/college-admin-dashboard/form-submissions",
        feature: "Form Submissions",
      },

      {
        title: "Student Resources",
        icon: "assignment",
        routerLink:
          "/college-admin-dashboard/student-resources",
        feature: "Student Resources",
      },

      {
        title: "Student Profile",
        icon: "account_circle",
        routerLink:
          "/college-admin-dashboard/student-profile",
        feature: "Student Profile",
      },

    ],
  },

  {
    title: "Certifications",
    icon: "verified_user",
    routerLink: null as any,
    subItems: [
      {
        title: "Clearance",
        routerLink:
          "/college-admin-dashboard/clearance",
        feature: "Clearance",
      },
      {
        title: "Checklist",
        routerLink:
          "/college-admin-dashboard/checklist",
        feature: "Checklist",
      },
      {
        title: "Checklist Form",
        routerLink:
          "/college-admin-dashboard/checklist-form",
        feature: "Checklist Form",
      },
      {
        title: "Completion",
        routerLink:
          "/college-admin-dashboard/completion",
        feature: "Completion",
      },
      {
        title: "Transcripts",
        routerLink:
          "/college-admin-dashboard/transcript",
        feature: "Transcripts",
      },
    ],
  },
  {
    title: "Document Center",
    icon: 'folder',
    routerLink: "/college-admin-dashboard/documents",
  },
  /* =========================
     Finance
  ========================== */
  {
    title: "Finance",
    icon: "account_balance",
    routerLink: null as any,
    subItems: [
      {
        title: "Payment Overview",
        routerLink:
          "/college-admin-dashboard/payment-overview",
        feature: "Payment Overview",
      },

      {
        title: "Payment Transactions",
        routerLink:
          "/college-admin-dashboard/payment-summary",
        feature: "Payment Transactions",
      },

      {
        title: "Payment Schedule",
        routerLink:
          "/college-admin-dashboard/payment-schedule",
        feature: "Payment Schedule",
      },

      {
        title: "Expenses",
        routerLink: null as any,
        subItems: [
          {
            title: "Expense Categories",
            routerLink:
              "/college-admin-dashboard/expenses/expense-category",
          },
          {
            title: "Expense Records",
            routerLink:
              "/college-admin-dashboard/expenses/expense",
          },
        ],
      },

      {
        title: "Refunds",
        routerLink:
          "/college-admin-dashboard/refunds",
        feature: "Refunds",
      },

      {
        title: "Payment Reports",
        routerLink:
          "/college-admin-dashboard/payments-report",
        feature: "Payment Report",
      },

      {
        title: "Revenue Reports",
        routerLink:
          "/college-admin-dashboard/revenue-report",
        feature: "Revenue Report",
      },
    ],
  },

  /* =========================
     Communications
  ========================== */
  {
    title: "Communications",
    icon: "announcement",
    routerLink: null as any,
    subItems: [
      {
        title: "Announcements",
        routerLink:
          "/college-admin-dashboard/announcements",
        feature: "Announcements",
      },

      {
        title: "Message Center",
        routerLink:
          "/college-admin-dashboard/message-center",
      },

      {
        title: "Message Panel",
        routerLink:
          "/college-admin-dashboard/message-panel",
      },

      {
        title: "Email Notifications",
        routerLink:
          "/college-admin-dashboard/email-notifications",
        feature: "Email Notifications",
      },
      {
        title: "Email Usage",
        routerLink:
          "/college-admin-dashboard/mail-usage",
        feature: "Email Notifications",
      },

      {
        title: "Callpad",
        icon: "dialpad",
        routerLink:
          "/college-admin-dashboard/callpad",
        feature: "Callpad",
      },
    ],
  },

  /* =========================
     HR & Administration
  ========================== */
  {
    title: "HR & Administration",
    icon: "admin_panel_settings",
    routerLink: null as any,
    subItems: [
      {
        title: "Users",
        routerLink: "/college-admin-dashboard/users",
        feature: "Users",
      },

      {
        title: "Departments",
        routerLink:
          "/college-admin-dashboard/department",
      },

      {
        title: "Positions",
        icon: "work_outline",
        routerLink:
          "/college-admin-dashboard/positions",
      },

      {
        title: "Job Placements",
        icon: "work",
        routerLink:
          "/college-admin-dashboard/jobs",
      },
      {
        title: "Hired Applicants",
        routerLink: "/college-admin-dashboard/hired-applicants",

      },

      {
        title: "Permissions",
        routerLink: null as any,
        subItems: [
          {
            title: "User Permissions",
            routerLink:
              "/college-admin-dashboard/permissions/user-permissions",
          },
          {
            title: "Role Permissions",
            routerLink:
              "/college-admin-dashboard/permissions/role-permissions",
          },
        ],
      },

      {
        title: "Audit Logs",
        icon: "account_circle",
        routerLink:
          "/college-admin-dashboard/audit-log",
      },
    ],
  },

  /* =========================
     Reports
     (kept because not in requested order)
  ========================== */
  {
    title: "Reports",
    icon: "analytics",
    routerLink: null as any,
    subItems: [
      {
        title: "Application Report",
        routerLink:
          "/college-admin-dashboard/application-report",
        feature: "Application Report",
      },
      {
        title: "Employment Status Report",
        routerLink:
          "/college-admin-dashboard/employment-status-report",
        feature: "Employment Status Report",
      },
    ],
  },

  /* =========================
     Settings
  ========================== */
  {
    title: "Settings",
    icon: "settings",
    routerLink: null as any,
    subItems: [
      {
        title: "Templates",
        routerLink:
          "/college-admin-dashboard/college-template",
        feature: "Templates",
      },

      {
        title: "Billing",
        icon: "receipt_long",
        routerLink: null as any,
        subItems: [
          {
            title: "Subscription",
            routerLink:
              "/college-admin-dashboard/subscription",
            feature: "Subscription",
          },
          {
            title: "Invoices",
            routerLink:
              "/college-admin-dashboard/invoices",
            feature: "Invoices",
          },
          {
            title: "Payments",
            routerLink:
              "/college-admin-dashboard/payment-billing",
            feature: "Payment",
          },
        ],
      },

      {
        title: "Payment Settings",
        routerLink:
          "/college-admin-dashboard/payment-options",
        feature: "Payment Settings",
      },

      {
        title: "College Profile",
        icon: "account_circle",
        routerLink:
          "/college-admin-dashboard/college-profile",
        feature: "College Profile",
      },

      {
        title: "System Settings",
        routerLink: "/college-admin-dashboard/settings/security",

      },
    ],
  },
];